var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.772 16.4714C14.3734 16.4714 13.2292 17.5999 13.2292 18.9791C13.2292 20.3584 14.3734 21.4868 15.772 21.4868C17.1706 21.4868 18.3149 20.3584 18.3149 18.9791C18.3149 17.5999 17.1706 16.4714 15.772 16.4714ZM23.4006 10.2022H22.1292V7.69452C22.1292 4.23391 19.2812 1.42529 15.772 1.42529C12.8732 1.42529 10.343 3.35622 9.6183 6.12722C9.53064 6.46064 9.41487 7.69452 9.41487 7.69452C9.41487 8.32145 9.41487 10.2022 9.41487 10.2022H11.9577C11.9577 10.2022 11.9577 8.94837 11.9577 7.69452C11.9759 7.22662 12.059 6.85241 12.0849 6.75414C12.5172 5.09906 14.0302 3.93298 15.772 3.93298C17.8699 3.93298 19.5863 5.62568 19.5863 7.69452V10.2022H11.9577H9.41487H8.14344C6.74487 10.2022 5.60059 11.3307 5.60059 12.7099V25.2484C5.60059 26.6276 6.74487 27.7561 8.14344 27.7561H23.4006C24.7992 27.7561 25.9434 26.6276 25.9434 25.2484V12.7099C25.9434 11.3307 24.7992 10.2022 23.4006 10.2022ZM23.4006 23.9945C23.4006 24.6841 22.8284 25.2484 22.1292 25.2484H9.41487C8.71559 25.2484 8.14344 24.6841 8.14344 23.9945V13.9638C8.14344 13.2741 8.71559 12.7099 9.41487 12.7099H22.1292C22.8284 12.7099 23.4006 13.2741 23.4006 13.9638V23.9945Z",
    fill: "url(#paint0_linear_1162_73956)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1162_73956",
    x1: 25.9434,
    y1: 27.7561,
    x2: -0.0981225,
    y2: 9.59828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE9142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCE6D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.767b2aae7008c963e3202ebcde53d456.svg";
export { ForwardRef as ReactComponent };